import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getLocationText } from '../../../utils/geo';
import InfiniteScroll from 'react-infinite-scroller';
import SortByFilter from './SortByFilter';
import Filters from './Filters';
import Display from '../../Display';
import { connect } from 'react-redux';
import { filterRides } from '../actions';
import {
  changeCurrentJourney,
  resetPreviewedJourney,
  previewJourney,
} from './actions';
import moment from 'moment-timezone';
import 'moment-duration-format';
import { translate } from 'react-i18next';
import { SidebarFooter } from '../SidebarFooter/index';
import { NoRides } from '../../NoRides';

export const SORT_BY = ['distance', 'starttime', 'duration', 'fuelConsumption'];
const initialState = {
  sortBy: 'starttime',
  sortByOpened: false,
  sortDirection: false, // descending
  filtersOpened: false,
  distance: [0, 1000],
  duration: [0, 720],
  range: [moment().subtract(1, 'months'), moment()],
  page: 0,
};

export class ListSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = props.filterObject.params
      ? {
          ...initialState,
          distance: [
            props.filterObject.params.DistanceFrom / 1000,
            props.filterObject.params.DistanceUpTo / 1000,
          ],
          duration: [
            props.filterObject.params.DurationFrom / 60,
            props.filterObject.params.DurationUpTo / 60,
          ],
          range: [
            moment(props.filterObject.params.From),
            moment(props.filterObject.params.UpTo),
          ],
        }
      : initialState;
    this.timeout = null;
    this.queue = null;
    this.changeSortBy = this.changeSortBy.bind(this);
    this.openSortBy = this.openSortBy.bind(this);
    this.changeSortDirection = this.changeSortDirection.bind(this);
    this.toggleFilters = this.toggleFilters.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.filter = this.filter.bind(this);
    this.showJourney = this.showJourney.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filterObject.params) {
      this.setState({
        distance: [
          nextProps.filterObject.params.DistanceFrom / 1000,
          nextProps.filterObject.params.DistanceUpTo / 1000,
        ],
        duration: [
          nextProps.filterObject.params.DurationFrom / 60,
          nextProps.filterObject.params.DurationUpTo / 60,
        ],
        range: [
          moment(nextProps.filterObject.params.From),
          moment(nextProps.filterObject.params.UpTo),
        ],
        page: nextProps.filterObject.params.Skip / 10,
      });
    }

    if (
      nextProps.journeys !== this.props.journeys ||
      nextProps.currentDeviceStats.deviceId !==
        this.props.currentDeviceStats.deviceId
    ) {
      this.setState({
        fetching: false,
      });
    }
  }

  getRangeLabel() {
    const [m1, m2] = this.state.range;
    return `${m1.format('DD MMMM')} - ${m2.format('DD MMMM YYYY')}`;
  }

  changeSortBy(event) {
    event.preventDefault();
    this.setState(
      {
        sortBy: event.target.id,
        sortByOpened: false,
        filtersOpened: false,
        page: 0,
      },
      this.filter,
    );
  }

  openSortBy(event) {
    event.preventDefault();
    this.setState({
      sortByOpened: !this.state.sortByOpened,
      filtersOpened: false,
    });
  }

  changeSortDirection(event) {
    event.preventDefault();
    this.setState(
      {
        sortDirection: !this.state.sortDirection,
        page: 0,
      },
      this.filter,
    );
  }

  toggleFilters(event) {
    event.preventDefault();
    this.setState({
      filtersOpened: !this.state.filtersOpened,
      sortByOpened: false,
    });
  }

  applyFilter({ distance, duration, range }) {
    this.setState(
      {
        distance,
        duration,
        range,
        page: 0,
      },
      this.filter,
    );
  }

  filter() {
    const { distance, duration, sortBy, sortDirection, range } = this.state;

    this.props.filter({
      distance,
      duration,
      sortBy,
      sortDirection,
      range,
      page: 0,
    });
  }

  clearFilter(event = null) {
    if (event) event.preventDefault();
    console.log('clear filter');
    this.setState(initialState, this.filter);
  }

  componentDidMount() {
    this.clearFilter();
  }

  loadMore() {
    this.setState(
      {
        page: this.state.page + 1,
        fetching: true,
      },
      () => {
        const {
          distance,
          duration,
          sortBy,
          sortDirection,
          range,
          page,
        } = this.state;
        this.props.filter({
          distance,
          duration,
          sortBy,
          sortDirection,
          range,
          page,
        });
      },
    );
  }

  showJourney(e, journey) {
    e.preventDefault();
    this.props.showJourney({ journey });
  }

  previewJourney(e, journey) {
    if (this.timeout) {
      this.queue = journey;
    } else {
      this.timeout = true;
      setTimeout(() => {
        if (this.queue) {
          this.props.handleJourneyPreview({ journey: this.queue });
        } else {
          this.props.handleJourneyPreview({ journey });
        }
        this.queue = null;
        this.timeout = null;
      }, 750);
    }
    // this.timeout = setTimeout(() => {
    //   // this.props.handlePreviewedJourneyReset();
    //   this.props.handleJourneyPreview({ journey });
    // }, 500);
  }

  cancelPreview() {
    clearTimeout(this.timeout);
  }

  render() {
    const { isShown, t, journeys, ridesLoaded } = this.props;
    const hoursText = t('dashboard:hours');
    const daysText = t('dashboard:days');
    const minsText = t('dashboard:min');
    const kmText = t('dashboard:km');

    return (
      <aside
        className="aside aside-gray"
        style={!isShown ? { display: 'none' } : {}}
      >
        {ridesLoaded && (
          <div className="aside__filter">
            <div className="aside__filter__result">
              {this.props.totalCount} {t('list-sidebar:rides')}
            </div>
            <div className="aside__filter__holder">
              <SortByFilter
                changeSortBy={this.changeSortBy}
                sortBy={this.state.sortBy}
              />
              <div className="aside__filter__btn__wrap">
                <a
                  href="#"
                  onClick={this.changeSortDirection}
                  className={`aside__filter__btn aside__filter__btn-sorting aside__filter__btn-sorting-${
                    this.state.sortDirection ? 'up' : 'down'
                  }`}
                />
              </div>
              <Filters
                distance={this.state.distance}
                duration={this.state.duration}
                range={this.state.range}
                clearFilter={this.clearFilter}
                applyFilter={this.applyFilter}
              />
            </div>
          </div>
        )}
        
        <Display isShown={!ridesLoaded}>
          <div className="spinner centered a" />
        </Display>
        <Display
          isShown={journeys.length === 0 && ridesLoaded}
          style={{ height: '100%', paddingBottom: '190px' }}
        >
          <NoRides />
        </Display>
        <Display isShown={journeys.length > 0} className="aside-scroll">
          <div
            style={{ height: '100%', overflow: 'auto' }}
            className="map-events-list"
          >
            <InfiniteScroll
              pageStart={0}
              loadMore={this.loadMore}
              loader={<div className="spinner" />}
              hasMore={this.props.hasMore && !this.state.fetching}
              useWindow={false}
              initialLoad={false}
              threshold={250}
            >
              {this.props.journeys.map(journey => {
                return (
                  <div key={journey.id} className="map-events-list__item">
                    <a
                      className="link"
                      href=""
                      onClick={e => this.showJourney(e, journey)}
                      onMouseEnter={e => this.previewJourney(e, journey)}
                      onMouseLeave={e => this.cancelPreview(e, journey)}
                    />
                    <div className="map-events-list__item__holder">
                      <span
                        className="progress-circle"
                        data-progress={journey.scoring.score}
                      >
                        <span>
                          <em />
                        </span>
                        <span>
                          <em />
                        </span>
                      </span>
                      <div className="map-events-list__item__wrap">
                        <div className="map-events-list__item__address">
                          <div className="point">
                            <span>a</span>
                          </div>
                          <div className="holder">
                            {journey.geoData &&
                              getLocationText(journey.geoData.start)}
                            <span className="time">
                              <span>
                                {moment(
                                  journey.journey.stat.startTime * 1000,
                                ).format('HH:mm')}
                              </span>
                              {moment(
                                journey.journey.stat.startTime * 1000,
                              ).format('DD MMMM')}
                            </span>
                          </div>
                        </div>
                        <div className="map-events-list__item__address">
                          <div className="point">
                            <span>b</span>
                          </div>
                          <div className="holder">
                            {journey.geoData &&
                              getLocationText(journey.geoData.finish)}
                            <span className="time">
                              <span>
                                {moment(
                                  journey.journey.stat.finishTime * 1000,
                                ).format('HH:mm')}
                              </span>
                              {moment(
                                journey.journey.stat.finishTime * 1000,
                              ).format('DD MMMM')}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="map-events-list__item__status">
                      <div className="text">
                        {Math.round(journey.journey.stat.distance / 1000 * 10) /
                          10}{' '}
                        {kmText}
                        {t('list-sidebar:for')}{' '}
                        {moment
                          .duration(journey.journey.stat.duration, 'seconds')
                          .format(
                            `d [${daysText}] h [${hoursText}] m [${minsText}]`,
                          )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </InfiniteScroll>
          </div>
        </Display>
        <SidebarFooter />
      </aside>
    );
  }
}

ListSidebar.propTypes = {
  journeys: PropTypes.array,
  totalCount: PropTypes.number,
  hasMore: PropTypes.bool,
  filter: PropTypes.func,
  filterObject: PropTypes.object,
  showJourney: PropTypes.func,
  handleJourneyPreview: PropTypes.func,
  handlePreviewedJourneyReset: PropTypes.func,
  isShown: PropTypes.bool,
  ridesLoaded: PropTypes.bool,
};

export default translate(['list-sidebar', 'dashboard'], { wait: true })(
  connect(
    state => ({
      journeys: state.rides.journeys,
      totalCount: state.rides.totalCount,
      hasMore: state.rides.hasMore,
      filterObject: state.rides.filter,
      currentDeviceStats: state.devices.currentDeviceStats,
      ridesLoaded: state.rides.journeysLoaded,
    }),
    {
      filter: filterRides,
      showJourney: changeCurrentJourney,
      handleJourneyPreview: previewJourney,
      handlePreviewedJourneyReset: resetPreviewedJourney,
    },
  )(ListSidebar),
);



// WEBPACK FOOTER //
// ./src/components/Sidebar/RidesSidebar/ListSidebar.js